import React, {Component} from 'react';
import axios from 'axios';
import {withRouter} from 'react-router-dom';
import ReactGA from 'react-ga';
import GoogleMapReact from 'google-map-react';
import {ToastContainer, ToastStore} from 'react-toasts';
import LostItemFunctions from '../LostItem/LostItemFunctions';
//import ExifOrientationImg from 'react-exif-orientation-img'
import {SERVER_URL, LOCAL_URL}  from '../Constants';
import MetaTags from 'react-meta-tags';
import MobileStoreButton from 'react-mobile-store-button';
import {Helmet} from "react-helmet";
import {
    FacebookShareButton,
    GooglePlusShareButton,
    //LinkedinShareButton,
    TwitterShareButton,
    //TelegramShareButton,
    //WhatsappShareButton,
    PinterestShareButton,

  } from 'react-share';

  import {
    FacebookIcon,
    TwitterIcon,
    //TelegramIcon,
    //WhatsappIcon,
    GooglePlusIcon,
    //LinkedinIcon,
    PinterestIcon,
    //VKIcon,
    //OKIcon,
    //RedditIcon,
    //TumblrIcon,
    //LivejournalIcon,
    //MailruIcon,
    //ViberIcon,
    //WorkplaceIcon,
    //LineIcon,
    //EmailIcon,
  } from 'react-share';

const ssKeywords = "#lostandfound #bounte #lostitem #founditem #bounty #rewardiffound #bountyhunter";


const AnyReactComponent = ({ text }) => <div><img src ="../images/pin.png" width="50px" height="50px" alt=""/></div>;

class SocialShare extends Component {

    constructor(props) {
      super(props);

      this.state = {
        center: {
            lat: 40,
            lng: -70,
          },
          zoom: 11,
        
      };
  
    }

    trackMe=(lostItemId)=>{
        try {
            ReactGA.pageview('/SocialShare:' + lostItemId);
        }catch(e){
            //dont care
           
        }
    }

 

    async componentDidMount() {
      
        try {
            //console.log(this.props);
            
            this.trackMe(this.props.lostItemId);

           if (!this.props.lostItemId){
             
                ToastStore.error("Invalid or missing portal id");
                return;
           }

        axios.get(SERVER_URL +  '/Portal/LostItem/' + this.props.lostItemId).then((res)=>{
            
            if (res.status === 401) {
              //place your reentry code
              console.log("Error" + res.status);
             
             }
    
    
            const lostItem = res.data;
            if (lostItem){
              this.setState({
                lostItem : lostItem,
                lostItemId: lostItem.id,
                itemState:lostItem.itemState,
                shortDescription: lostItem.shortDescription,
                longDescription: lostItem.longDescription, 
                url: lostItem.url, 
                center:  {
                  lat: lostItem.latitude,
                 lng: lostItem.longitude
                },
                published : lostItem.published,
                publishedDate: lostItem.publishedDate,
                foundDate: (lostItem.foundDate) ? new Date(lostItem.foundDate) : new Date(),
                is_found: lostItem.is_found,
                bounty:lostItem.bounty,
                zoom: 14,
                socialquote:(lostItem.is_found===true) ? 'Found: ' + lostItem.shortDescription : 'Lost: ' + lostItem.shortDescription,
                socialHash : ssKeywords,
                socialUrl: `${LOCAL_URL}/SocialShare?lostitemid=${lostItem.id}`,

                });
                console.log(this.state.socialUrl);
            }
            }).catch((e)=>{ 
              
              ToastStore.error("An error occured. Please try again");
            });
          }
            catch(e){
              //ToastStore.error(e.response);
            }
        
        
     
      }
    renderToast=()=>{
        return <div>
            
            <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
        </div>
      }



    
   


      
renderMetaTags=()=>{

    
}



  render() {
    return(
        
    <div  className='jumbotron '>

             <Helmet>
             <meta property="og:image" content={this.state.url}/>
            </Helmet>

            <MetaTags>
            <title>Bounte: Lost & Found Items</title>
            <meta property="og:locale" content="en_US" />
            <meta property="og:url" content={`${LOCAL_URL}/SocialShare?lostitemid=${this.state.lostItemId}`} />
            <meta property="og:type" content="article" />
            <meta property="og:title" content={(this.state.is_found===true) ? 'Found: ' + this.state.shortDescription : 'Lost: ' + this.state.shortDescription}  />

            <meta name="og:description" content={this.state.shortDescription} />
            <meta property="og:image" content={this.state.url}/>
            <meta property="og:image:width" content="500"/>
            <meta property="og:image:height" content="500"/>
            <meta property="fb:app_id" content="479843715546485"/>
          </MetaTags>

                {this.renderToast()}
                
        
        <div className='row'>
                <div className='col-12 text-center '>
                <a href='http://bounte.net'>
                <img src={`${LOCAL_URL}/images/logo.png`} style={{width: '50px', height:'50px'}} alt=''/>
                </a>
                </div>
        </div>

        <div className='row'>
       
            <div className='col-12 text-center '>
                <h1 className="display-3">{(this.state.is_found)? 'FOUND ITEM': 'LOST ITEM'}</h1>
                <br/>
                <h2 className="display-5">{this.state.shortDescription}</h2>
                <br/>
                <p className="lead"><b>Date Lost/Found:</b>  {LostItemFunctions.formatDateLongDate(this.state.foundDate)}</p>  

            </div>
        </div>
        <div className='row'>
                <div className='col-12 text-center '>
                <img style={{width: '250px', height:'250px'}} src={this.state.url} alt={this.state.shortDescription}/> 
                </div>
        </div>
        <div className='row'>
                <div className='col-12 text-center '>
                Description: 
                <h5 className="display-5">{this.state.longDescription}</h5>
                Bounty: <h5 className="display-5">${this.state.bounty}</h5>
                </div>
        </div>

        
        <div className='row' >
                <div className='col-12 center-block' align="center">
                    <div style={{ height: '500px', width: '500px' }}>
                    <GoogleMapReact
                                    bootstrapURLKeys={{ key: "AIzaSyA6F5Cxr4qlW8xqS3qcDsTFG7YAbUriD8E" }}
                                    center={this.state.center}
                                    zoom={this.state.zoom}
                                    defaultCenter={{lat:4.352130,lng:50.845926}}
                                    defaultZoom={90}
                                >
                                    <AnyReactComponent
                                    lat={this.state.center.lat}
                                    lng={this.state.center.lng}
                                    text={'item'}
                                    />
                                </GoogleMapReact>
                                </div>
                </div>
        </div>
        <br/> <br/>
         <div className='row'>
                <div className='col-12 text-center '>
                <h6> Download the App to help find or claim your item! </h6>
                </div>
        </div>


      
        <br/>
        <div className='row justify-content-center' >
            <div  >
            <MobileStoreButton
                  store="ios"
                  width={150}
                  url={"https://itunes.apple.com/us/app/bounte/id1262003089?mt=8"}
                  linkProps={{ title: 'iOS Store Button' }}/>

          
            </div>
            <div >
            <MobileStoreButton
                  store="android"
                  width={150}
                  url={"https://play.google.com/store/apps/details?id=com.bounte"}
                  linkProps={{ title: 'Google Play Store Button' }}/>


          
	            </div>
        </div>

  
        <div className='row justify-content-center' >
           
                <div  style={{width:50}}>
                    <FacebookShareButton url={this.state.socialUrl} quote={this.state.socialquote}  hashtag={this.state.socialHash}><FacebookIcon size={32} round={false} /></FacebookShareButton>
    
                </div>
                <div style={{width:50}}>
                        <TwitterShareButton url={this.state.socialUrl} quote={this.state.socialquote}  hashtag={this.state.socialHash}><TwitterIcon size={32} round={false} /></TwitterShareButton>
 
                </div>
                <div style={{width:50}}>
                <GooglePlusShareButton url={this.state.socialUrl} quote={this.state.socialquote}  hashtag={this.state.socialHash}><GooglePlusIcon size={32} round={false} /></GooglePlusShareButton>
                  
                </div>
                <div style={{width:50}}>
                <PinterestShareButton url={this.state.socialUrl} quote={this.state.socialquote}  hashtag={this.state.socialHash}><PinterestIcon size={32} round={false} /></PinterestShareButton>
                  
                </div>
                
        </div>

    </div>
   
    )
 }


  
}


export default withRouter(SocialShare);